export const MINIMUM_INPUT_WIDTH = 11
